module.exports = __webpack_public_path__ + "static/media/Redesign.79c2c3e6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/Redesign.pdf
// module id = 177
// module chunks = 1